module.exports = __webpack_public_path__ + "static/img/subscribe_header.ac1eab56.png";